import { Skeleton } from 'ui/skeleton';
import { TextSkeletonWrapper } from 'modules/ai/copyAssist/components/dropdown/styles';

export const CopyAssistDropdownItemTextSkeleton = () => {
  return (
    <TextSkeletonWrapper data-test="copy-assist-loading-text-skeleton">
      <Skeleton height={16} isRound />
      <Skeleton height={16} width={300} isRound />
    </TextSkeletonWrapper>
  );
};
